import CryptoJS from 'crypto-js';

export const getPBKDF2Hashed = (value: string) =>
  CryptoJS.PBKDF2(value, CryptoJS.lib.WordArray.random(128 / 8), {
    keySize: 256 / 32,
    hasher: CryptoJS.algo.SHA256,
  }).toString();
